const state = {
    // 申込み時の新規か追加か変更かのステータス
    hasRegistration: 'new', // newが新規登録 addが商品追加 changeが変更 newが初期値
    // headerの申込みのキャンセルボタンの表示・非表示
    hasCancel: false, // trueが表示 falseが非表示 falseが初期値
    // 信販か自社割賦かのステータス
    hasPayment: 'credit', // creditが信販 installmentが自社割賦 creditが初期値
    // SMS認証が完了したかどうか？
    hasDoneSms: false, // trueが完了 falseが未完了
    // 未成年かどうか
    hasMinors: false, // trueが未成年 falseが成人
    // 登録が完了した申込ID
    hasContractId: null,
    // 信販 → 自社割賦 元の信販申込ID
    originalContractId: null,
    // 追加申込時に取得したTFIC識別ID
    localCustomerId: '',
    // 顧客区分 0:通常客|1:契約禁止|2:申込客|3:断り客
    refuseFlag: 0
}

const getters = {
    getHasRegistration(state) {
        return state.hasRegistration
    },
    getHasCancel(state) {
        return state.hasCancel
    },
    getHasPayment(state) {
        return state.hasPayment
    },
    getHasDoneSms(state) {
        return state.hasDoneSms
    },
    getHasMinors(state) {
        return state.hasMinors
    },
    getHasContractId(state) {
        return state.hasContractId
    },
    getOriginalContractId(state) {
        return state.originalContractId
    },
    getLocalCustomerId(state) {
        return state.localCustomerId
    },
    getRefuseFlag(state) {
        return state.refuseFlag
    }
}

const actions = {
    init({ commit }) {
        commit('updateHasRegistration', 'new')
        commit('updateHasCancel', false)
        commit('updateHasPayment', 'credit')
        commit('updateHasDoneSms', false)
        commit('updateHasMinors', false)
        commit('updateHasContractId', null)
        commit('updateLocalCustomerId', '')
        commit('updateRefuseFlag', 0)
    },
    updateHasRegistration({ commit }, status) {
        commit('updateHasRegistration', status)
    },
    updateHasCancel({ commit }, status) {
        commit('updateHasCancel', status)
    },
    updateHasPayment({ commit }, status) {
        commit('updateHasPayment', status)
    },
    updateHasDoneSms({ commit }, status) {
        commit('updateHasDoneSms', status)
    },
    updateHasMinors({ commit }, status) {
        commit('updateHasMinors', status)
    },
    updateHasContractId({ commit }, id) {
        commit('updateHasContractId', id)
    },
    updateOriginalContractId({ commit }, id) {
        commit('updateOriginalContractId', id)
    },
    updateLocalCustomerId({ commit }, id) {
        commit('updateLocalCustomerId', id)
    },
    updateRefuseFlag({ commit }, val) {
        commit('updateRefuseFlag', val)
    }
}

const mutations = {
    updateHasRegistration(state, status) {
        state.hasRegistration = status
    },
    updateHasCancel(state, status) {
        state.hasCancel = status
    },
    updateHasPayment(state, status) {
        state.hasPayment = status
    },
    updateHasDoneSms(state, status) {
        state.hasDoneSms = status
    },
    updateHasMinors(state, status) {
        state.hasMinors = status
    },
    updateHasContractId(state, id) {
        state.hasContractId = id
    },
    updateOriginalContractId(state, id) {
        state.originalContractId = id
    },
    updateLocalCustomerId(state, id) {
        state.localCustomerId = id
    },
    updateRefuseFlag(state, id) {
        state.refuseFlag = id
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}